import { useState } from "react";
import axios from "axios";
import refreshToken from "../services/authService";
import Cookies from 'js-cookie';

const useInsert = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const insertData = async (url, newData, onSuccess) => {
    setIsLoading(true);
    try {
      const accessToken = Cookies.get('access_token');
      const response = await axios.post(url, newData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      if (response.status !== 201) {
        throw new Error("Failed to insert data.");
      }

      setResponseData(response.data); // Set responseData in state
      setSuccessMessage("Data inserted successfully.");
      setIsLoading(false);

      // Pass responseData to onSuccess callback if provided
      if (onSuccess) {
        onSuccess(response.data); // Pass response data to the callback
      }

    } catch (error) {
      if (error.response) {
        setErrorMessage(error.response.data);
      } else if (error.request) {
        setErrorMessage("No response received from the server.");
      } else {
        setErrorMessage(error.message);
      }
      setIsLoading(false);
    }
  };

  return { insertData, isLoading, errorMessage, successMessage, responseData };
};

export default useInsert;

